import React, { useRef, useState } from "react";
import { Router, NavLink, Link } from "react-router-dom";

import "./Navbar.css";

import Logo from "../../assets/images/Le-petit-recycleur-logo-black.png";
import LogoUnique from "../../assets/images/unique_logo_1.png";

const Navbar = () => {
  const [link0, setLink0] = useState(true);
  const [link1, setLink1] = useState(false);
  const [link2, setLink2] = useState(false);
  const [link3, setLink3] = useState(false);
  const [link4, setLink4] = useState(false);

  const resetLink = () => {
    setLink0(false);
    setLink1(false);
    setLink2(false);
    setLink3(false);
    setLink4(false);
  };

  const setActiveLink = (index) => {
    console.log(index);
    resetLink();
    switch (index) {
      case 0:
        setLink0(true);
        break;
      case 1:
        setLink1(true);
        break;
      case 2:
        setLink2(true);
        break;
      case 3:
        setLink3(true);
        break;
      case 4:
        setLink4(true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="menu-desktop">
        <nav className="menu-global-container">
          <a className="menu-brand" href="/">
            <img src={Logo} className="menu-logo" alt="logo" />
          </a>
          <ul className="menu-list">
            {/* <li className="menu-item"><a className="menu-link" href="/scan">Scanner</a></li>
                  <li className="menu-item"><a className="menu-link" href="/recycling">Le recyclage</a></li>
                  <li className="menu-item"><a className="menu-link" href="/contribute">Contribuer</a></li>
                  <li className="menu-item"><a className="menu-link" href="/info">A propos</a></li> */}
            <NavLink activeclassname="active" exact="true" to="/scan">
              <li className="menu-item">Scanner</li>
            </NavLink>
            <NavLink activeclassname="active" exact="true" to="/recycling">
              <li className="menu-item">Le recyclage</li>
            </NavLink>
            <NavLink activeclassname="active" exact="true" to="/contribute">
              <li className="menu-item">Contribuer</li>
            </NavLink>
            <NavLink activeclassname="active" exact="true" to="/info">
              <li className="menu-item">A propos</li>
            </NavLink>
          </ul>
        </nav>
      </div>
      <div className="menu-mobile">
        <div className="top-mobile-logo-container">
          <NavLink to="/">
            <img src={Logo} className="top-mobile-logo" alt="logo mobile" />
          </NavLink>
        </div>
        <nav className="menu-global-container">
          <div className="dvNav">
            <NavLink activeclassname="active" exact="true" to="/">
              <i className="bi bi-house-door-fill"></i>
              <span className="icon-text">Home</span>
            </NavLink>
            <NavLink activeclassname="active" to="/recycling">
              <i className="bi bi-recycle"></i>
              <span className="icon-text">Recyclage</span>
            </NavLink>
            <NavLink activeclassname="active" to="/scan">
              <i className="bi bi-upc-scan"></i>
              <span className="icon-text">Scanner</span>
            </NavLink>
            <NavLink activeclassname="active" to="/contribute">
              <i className="bi bi-people-fill"></i>
              <span className="icon-text">Contribuer</span>
            </NavLink>
            <NavLink activeclassname="active" to="/info">
              <i className="bi bi-info-circle"></i>
              <span className="icon-text">Info</span>
            </NavLink>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
